import type { TimeSeriesPoint } from '../TimeSeriesChart.types';

/**
 * Indexes of the points that come after a gap: more than `gapThresholdMs` since the previous point.
 * Empty without a positive threshold. Points must be ascending by timestamp.
 */
export function findGapIndexes(points: readonly TimeSeriesPoint[], gapThresholdMs: number | undefined): number[] {
  if (gapThresholdMs === undefined || !(gapThresholdMs > 0)) {
    return [];
  }

  const gapIndexes: number[] = [];

  for (let index = 1; index < points.length; index += 1) {
    if (points[index].timestamp - points[index - 1].timestamp > gapThresholdMs) {
      gapIndexes.push(index);
    }
  }

  return gapIndexes;
}
